module.exports = __webpack_public_path__ + "img/vicon_rotaflow_ro_m_geospread.4dcb9217.jpg";